export default __webpack_public_path__ + "static/media/BeBackSoon.8d4ca048.png";